module.exports = __webpack_public_path__ + "static/media/automation-inner.5b07f552.png";